import { useMemo } from "react";

const useIsMobile = () => {
  const isMobile = useMemo(() => window.outerWidth < 991, [window.outerWidth]);
  return isMobile;
};
export default useIsMobile;
